function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DeleteOutline, FileUploadOutlined, InfoOutlined } from "@mui/icons-material";
import { FormHelperText, IconButton, styled } from "@mui/material";
import cn from "clsx";
import { flatten, uniq } from "lodash";
import { nanoid } from "nanoid";
import { useCallback, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useToggle, useUpdateEffect } from "react-use";
import { Button } from "./Button";
import { Text } from "./Text";
var StyledListItem = styled('li')(function(props) {
    return {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: props.theme.spacing(4),
        paddingLeft: props.theme.spacing(2)
    };
});
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
var mimeTypes = {
    '.csv': 'text/csv',
    '.doc': 'application/msword',
    '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    '.jpeg': 'image/jpeg',
    '.jpg': 'image/jpeg',
    '.pdf': 'application/pdf',
    '.png': 'image/png',
    '.psv': 'text/psv',
    '.txt': 'text/plain',
    '.webp': 'image/webp',
    '.xls': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.xlsx': 'application/vnd.ms-excel'
};
function readFiles(files, readFileAs, group, documentKey) {
    return _readFiles.apply(this, arguments);
}
function _readFiles() {
    _readFiles = _async_to_generator(function(files, readFileAs, group, documentKey) {
        var _loop, result, i;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(i) {
                        var _;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _ = result.push;
                                    return [
                                        4,
                                        new Promise(function(resolve, reject) {
                                            var reader = new FileReader();
                                            reader.onabort = function() {
                                                return reject('aborted');
                                            };
                                            reader.onerror = function(e) {
                                                return reject(e);
                                            };
                                            reader.onload = function(e) {
                                                return resolve({
                                                    data: e.target.result,
                                                    documentKey: documentKey,
                                                    group: group,
                                                    id: nanoid(),
                                                    path: files[i].name,
                                                    type: files[i].type
                                                });
                                            };
                                            switch(readFileAs){
                                                case 'binary':
                                                    reader.readAsBinaryString(files[i]);
                                                    break;
                                                case 'base64':
                                                    reader.readAsDataURL(files[i]);
                                                    break;
                                                default:
                                                    reader.readAsBinaryString(files[i]);
                                            }
                                        })
                                    ];
                                case 1:
                                    _.apply(result, [
                                        _state.sent()
                                    ]);
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    result = [];
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < files.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        _ts_values(_loop(i))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _readFiles.apply(this, arguments);
}
export var FileUploader = function(_param) {
    var _param_buttonLabel = _param.buttonLabel, buttonLabel = _param_buttonLabel === void 0 ? 'Upload' : _param_buttonLabel, _param_multiple = _param.multiple, multiple = _param_multiple === void 0 ? false : _param_multiple, _param_readFileAs = _param.readFileAs, readFileAs = _param_readFileAs === void 0 ? 'binary' : _param_readFileAs, props = _object_without_properties(_param, [
        "buttonLabel",
        "multiple",
        "readFileAs"
    ]);
    var _useState = _sliced_to_array(useState(props.value || []), 2), files = _useState[0], setFiles = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), errors = _useState1[0], setErrors = _useState1[1];
    var _useToggle = _sliced_to_array(useToggle(false), 2), isDisabled = _useToggle[0], toggleDisabled = _useToggle[1];
    var onUpload = useCallback(function() {
        var _ref = _async_to_generator(function(acceptedFiles) {
            var readedFiles, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            4,
                            5
                        ]);
                        setErrors([]);
                        toggleDisabled(true);
                        return [
                            4,
                            readFiles(acceptedFiles, readFileAs, props.group, props.documentKey)
                        ];
                    case 1:
                        readedFiles = _state.sent();
                        return [
                            4,
                            props.onUpload(readedFiles)
                        ];
                    case 2:
                        _state.sent();
                        // wait for errors to be removed from formik before showing files
                        // this way we avoid having on the screen at the same time
                        setTimeout(function() {
                            setFiles(readedFiles);
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setErrors([
                            'The selected file could not be uploaded – try again'
                        ]);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        toggleDisabled(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(acceptedFiles) {
            return _ref.apply(this, arguments);
        };
    }(), [
        files
    ]);
    var onRemove = useCallback(function() {
        var _ref = _async_to_generator(function(file) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            props.onRemove(file)
                        ];
                    case 1:
                        _state.sent();
                        setFiles(files.filter(function(f) {
                            return f.id !== file.id;
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }(), [
        props.onRemove,
        files
    ]);
    var accept = useMemo(function() {
        return props.accept.filter(function(item) {
            return !!mimeTypes[item];
        }).reduce(function(acc, cur) {
            return _object_spread_props(_object_spread({}, acc), _define_property({}, mimeTypes[cur], [
                cur
            ]));
        }, {});
    }, [
        props.accept
    ]);
    var maxSizeToBytes = useMemo(function() {
        return props.maxSize * 1024 * 1024;
    }, [
        props.maxSize
    ]);
    var _useDropzone = useDropzone({
        accept: accept,
        maxSize: maxSizeToBytes,
        multiple: multiple,
        noDrag: true,
        onDrop: onUpload
    }), getRootProps = _useDropzone.getRootProps, getInputProps = _useDropzone.getInputProps, fileRejections = _useDropzone.fileRejections;
    var errorsSchema = useMemo(function() {
        return {
            'file-invalid-type': "Unsupported format: The selected file must be a ".concat(props.accept.join(', ')),
            'file-too-large': "The selected file must be smaller than ".concat(props.maxSize, " Mb")
        };
    }, [
        props.maxSize,
        props.accept
    ]);
    useUpdateEffect(function() {
        if (fileRejections === null || fileRejections === void 0 ? void 0 : fileRejections.length) {
            var errors = uniq(flatten(fileRejections.map(function(fr) {
                return fr.errors;
            })).map(function(error) {
                return error.code;
            }));
            setErrors(errors.map(function(error) {
                return errorsSchema[error] || 'The selected file could not be uploaded – try again';
            }));
        }
    }, [
        fileRejections
    ]);
    useUpdateEffect(function() {
        setFiles(props.value);
    }, [
        props.value
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: props.className,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        color: errors.length || props.error ? 'error' : 'grey100',
                        mb: 2,
                        variant: "g2",
                        children: props.title
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        color: "grey300",
                        mb: errors.length ? 2 : 4,
                        variant: "i2",
                        children: props.caption
                    }),
                    errors.map(function(err) {
                        return /*#__PURE__*/ _jsx(Text, {
                            color: "error",
                            variant: "i2",
                            children: err
                        }, err);
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, getRootProps()), {
                children: [
                    /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({}, getInputProps()), {
                        "data-testid": "uploadInput"
                    })),
                    /*#__PURE__*/ _jsxs(Button, {
                        disabled: !multiple && !!files.length || isDisabled,
                        variant: "outlined",
                        children: [
                            /*#__PURE__*/ _jsx(FileUploadOutlined, {
                                className: "mr-1",
                                fontSize: "small"
                            }),
                            buttonLabel
                        ]
                    })
                ]
            })),
            /*#__PURE__*/ _jsx("ul", {
                className: "mt-4",
                children: files.map(function(file) {
                    return /*#__PURE__*/ _jsxs(StyledListItem, {
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                color: "grey100",
                                mb: 0,
                                variant: "i2",
                                children: file.path
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                className: "text-grey300",
                                onClick: function() {
                                    return onRemove(file);
                                },
                                size: "small",
                                title: "Delete",
                                children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                    color: "inherit"
                                })
                            })
                        ]
                    }, file.id);
                })
            }),
            /*#__PURE__*/ _jsx(FormHelperText, {
                "aria-atomic": "true",
                className: cn('mx-0', {
                    'mb-8': !files.length
                }),
                "data-component": "fileUploaderError",
                role: "alert",
                children: !props.hideError && props.error ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(InfoOutlined, {
                            className: "mr-1",
                            color: "error",
                            fontSize: "small"
                        }),
                        !!props.title && /*#__PURE__*/ _jsxs("span", {
                            className: "sr-only",
                            children: [
                                "Error for ",
                                props.title,
                                ":"
                            ]
                        }),
                        props.error
                    ]
                }) : ' '
            })
        ]
    });
};
FileUploader.displayName = 'FileUploader';

//# sourceMappingURL=FileUploader.js.map